module.exports = __webpack_public_path__ + "static/media/favicon.5974bb19.ico";